/* ==========================================================================
   oé · Agregar rápido (estilo Oner Active)
   En computador, al pasar el cursor por una prenda aparece un panel blanco
   sobre la foto con los colores de la misma prenda y las tallas.
   - Clic en un color: la tarjeta cambia a ese color (foto, link, tallas).
   - Clic en una talla: se agrega al carrito y se abre el carrito lateral.
   Datos: /collections/all?view=oe-familias (templates/collection.oe-familias.liquid)
   ========================================================================== */
(function () {
  'use strict';
  if (window.oeQuickAdd) return;
  window.oeQuickAdd = true;

  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var cfg = window.oeWishConfig || {};
  var root = (cfg.root || '/').replace(/\/?$/, '/');
  var KEY = 'oe_qa_data_v2';
  var TTL = 5 * 60 * 1000;
  var MIN_WIDTH = 200;
  var MAX_COLORS = 8;
  var dataP = null;
  var byHandle = {};
  var byFam = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- datos ---------- */
  function index(list) {
    byHandle = {};
    byFam = {};
    list.forEach(function (p) {
      byHandle[p.h] = p;
      if (p.n) p.n = String(p.n).trim();
      /* los colores de una misma prenda son productos con el mismo nombre */
      p.k = String(p.t || '').toLowerCase().replace(/\s+/g, ' ').trim();
      if (p.k) (byFam[p.k] = byFam[p.k] || []).push(p);
    });
  }
  function fetchPage(n) {
    return fetch(root + 'collections/all?view=oe-familias&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function load() {
    if (dataP) return dataP;
    try {
      var c = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (c && c.p && Date.now() - c.t < TTL) {
        index(c.p);
        dataP = Promise.resolve();
        return dataP;
      }
    } catch (e) {}
    dataP = fetchPage(1)
      .then(function (first) {
        var pages = Math.min(first.pages || 1, 8);
        var rest = [];
        for (var i = 2; i <= pages; i++) rest.push(fetchPage(i));
        return Promise.all(rest).then(function (others) {
          var all = first.p.slice();
          others.forEach(function (o) { all = all.concat(o.p || []); });
          index(all);
          try { window.sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: all })); } catch (e) {}
        });
      })
      .catch(function () { dataP = null; });
    return dataP;
  }

  /* ---------- panel ---------- */
  function colorsFor(p) {
    var fam = p.k && byFam[p.k];
    return fam && fam.length > 1 ? fam : [];
  }

  function swatchStyle(c) {
    if (c.s) return 'background-color: rgb(' + c.s + ');';
    var img = c.si || c.i1;
    return img ? "background-image: url('" + img + "');" : '';
  }

  function sizesHTML(p) {
    var v = p.v || [];
    if (!v.length) return '';
    if (v.length === 1 && /default/i.test(v[0][1] || '')) {
      return '<div class="oe-qa__sizes"><button type="button" class="oe-qa__size oe-qa__size--wide" data-oe-qa-add="' + v[0][0] + '"' +
        (v[0][2] ? '' : ' disabled') + '>' + (v[0][2] ? 'Agregar al carrito' : 'Agotado') + '</button></div>';
    }
    return '<div class="oe-qa__sizes" role="group" aria-label="Elige tu talla">' +
      v.map(function (x) {
        return '<button type="button" class="oe-qa__size" data-oe-qa-add="' + x[0] + '"' +
          (x[2] ? ' aria-label="Agregar talla ' + esc(x[1]) + ' al carrito"' : ' disabled aria-disabled="true" title="Agotado"') +
          '>' + esc(x[1]) + '</button>';
      }).join('') +
      '</div>';
  }

  function panelHTML(p) {
    var colors = colorsFor(p);
    var html = '<p class="oe-qa__title">Agregar rápido</p>';
    if (colors.length) {
      html += '<div class="oe-qa__colors" role="group" aria-label="Colores">' +
        colors.slice(0, MAX_COLORS).map(function (c) {
          var label = c.n || c.t;
          return '<button type="button" class="oe-qa__color' + (c.h === p.h ? ' is-current' : '') + '" data-oe-qa-color="' + esc(c.h) + '"' +
            ' title="' + esc(label) + '" aria-label="Ver color ' + esc(label) + '"' + (c.h === p.h ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' +
            '<span style="' + swatchStyle(c) + '"></span></button>';
        }).join('') +
        (colors.length > MAX_COLORS ? '<span class="oe-qa__more">+' + (colors.length - MAX_COLORS) + '</span>' : '') +
        '</div>';
    }
    html += sizesHTML(p);
    html += '<p class="oe-qa__msg" hidden></p>';
    return html;
  }

  function handleFromCard(w) {
    var link = w.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function build(w) {
    if (w.__oeQaBuilt) return;
    var inner = w.querySelector('.card__inner');
    if (!inner || !w.querySelector('.card__media')) return;
    if (w.getBoundingClientRect().width < MIN_WIDTH) return;
    var p = byHandle[handleFromCard(w)];
    if (!p) return;
    w.__oeQaBuilt = true;
    var panel = document.createElement('div');
    panel.className = 'oe-qa';
    panel.setAttribute('data-handle', p.h);
    panel.innerHTML = panelHTML(p);
    inner.appendChild(panel);
    w.classList.add('oe-qa-ready');
  }

  /* ---------- cambiar de color ---------- */
  function swapCard(w, p) {
    var imgs = w.querySelectorAll('.card__media img');
    if (imgs[0] && p.i1) {
      imgs[0].removeAttribute('srcset');
      imgs[0].src = p.i1;
      imgs[0].alt = p.t;
    }
    if (imgs[1] && p.i2) {
      imgs[1].removeAttribute('srcset');
      imgs[1].src = p.i2;
      imgs[1].alt = p.t;
    }
    var url = root + 'products/' + p.h;
    w.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.setAttribute('href', url); });
    var colorText = w.querySelector('.card__color');
    if (colorText && p.n) colorText.textContent = p.n;
    var heart = w.querySelector('[data-oe-wish]');
    if (heart) {
      heart.setAttribute('data-oe-wish', p.h);
      heart.setAttribute('data-title', p.t);
      heart.setAttribute('data-url', location.origin + url);
      if (p.i1) heart.setAttribute('data-image', p.i1);
      if (window.oeWishlist && window.oeWishlist.sync) window.oeWishlist.sync();
    }
    var badge = w.querySelector('.card__badge');
    if (badge && /agotado|sold/i.test(badge.textContent)) badge.style.visibility = p.a ? 'hidden' : '';
    var panel = w.querySelector('.oe-qa');
    if (panel) {
      panel.setAttribute('data-handle', p.h);
      panel.innerHTML = panelHTML(p);
    }
  }

  /* ---------- agregar al carrito ---------- */
  function showMsg(panel, text) {
    var m = panel && panel.querySelector('.oe-qa__msg');
    if (!m) return;
    m.textContent = text;
    m.hidden = !text;
  }

  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-oe-qa-add'), 10);
    if (!id) return;
    var panel = btn.closest('.oe-qa');
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { id: id, quantity: 1 };
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = location.pathname;
    }
    btn.classList.add('is-loading');
    showMsg(panel, '');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok || res.data.status) {
          showMsg(panel, res.data.description || res.data.message || 'No pudimos agregar esta talla. Intenta de nuevo.');
          return;
        }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        if (cartDrawer && res.data.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(res.data);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        showMsg(panel, 'No pudimos agregar esta talla. Intenta de nuevo.');
      });
  }

  /* ---------- eventos ---------- */
  document.addEventListener('mouseover', function (e) {
    if (!mq.matches) return;
    var w = e.target.closest && e.target.closest('.card-wrapper');
    if (!w || w.__oeQaBuilt || w.__oeQaWaiting) return;
    if (w.closest('predictive-search') || w.closest('.quick-add-modal')) return;
    w.__oeQaWaiting = true;
    load().then(function () {
      w.__oeQaWaiting = false;
      build(w);
    });
  });

  document.addEventListener('click', function (e) {
    var panel = e.target.closest && e.target.closest('.oe-qa');
    if (!panel) return;
    e.preventDefault();
    e.stopPropagation();
    var colorBtn = e.target.closest('[data-oe-qa-color]');
    if (colorBtn) {
      var p = byHandle[colorBtn.getAttribute('data-oe-qa-color')];
      var w = panel.closest('.card-wrapper');
      if (p && w) swapCard(w, p);
      return;
    }
    var addBtn = e.target.closest('[data-oe-qa-add]');
    if (addBtn && !addBtn.disabled && !addBtn.classList.contains('is-loading')) addToCart(addBtn);
  }, true);

  /* precarga en silencio cuando hay tarjetas en la página */
  function preload() {
    if (!mq.matches || !document.querySelector('.card-wrapper')) return;
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); })(load);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preload);
  else preload();
})();
